import { useExperiment } from "src/modules/Experiments";

const useSearchExperiment = () => {
  const searchVariant = useExperiment('search');

  return searchVariant;
};

export default useSearchExperiment;
